var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { attrs: { id: "basic" } }, [
    _c("div", { staticClass: "results" }, [
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.searchResults
            ? _vm._l(_vm.searchResults.data, function (item, index) {
                return _c("provider", { key: index, attrs: { data: item } })
              })
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }